export const getStrapiURL = (path = "") => {
  let apiUrl = process.env.REACT_APP_API;

  console.log(process.env);

  return `${apiUrl}${path}`;
};

export const getStrapiMedia = (url) => {
  if (url == null) {
    return null;
  }

  // Return the full URL if it is already an absolute URL
  if (url.startsWith("http") || url.startsWith("//")) {
    return url;
  }

  // Otherwise prepends the Strapi URL to the path
  const apiUrl = process.env.REACT_APP_API;
  return `${apiUrl}${url}`;
};

export const transformStrapiArticle = (article) => {
  // Handle Strapi v4 structure (attributes) vs v5 (flat)
  const data = article.attributes ? article.attributes : article;
  const id = article.id;

  return {
    _id: id,
    title: data.title,
    slug: data.slug,
    content: transformContent(data.content || data.blocks, data.cover),
    // Handle tags: v4 uses .data, v5 might be direct array
    tags: (
      data.tags?.data ||
      data.tags ||
      (data.category ? [data.category] : []) ||
      []
    ).map((tag) => {
      // v4 tag inside .attributes, v5 tag is direct
      return tag.attributes?.name || tag.name;
    }),
    // Handle author: v4 uses .data.attributes, v5 is direct object
    author: data.author?.data?.attributes?.name || data.author?.name || "Admin",
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    publishedAt: data.publishedAt,
    description: data.description,
  };
};

const transformContent = (contentBlocks, cover) => {
  const transformed = [];

  // Add cover image as the first content block if it exists
  if (cover) {
    let coverUrl = null;
    if (cover.data?.attributes?.url) {
      coverUrl = cover.data.attributes.url; // v4
    } else if (cover.url) {
      coverUrl = cover.url; // v5 flat
    }

    if (coverUrl) {
      transformed.push({
        type: "image",
        value: getStrapiMedia(coverUrl),
      });
    }
  }

  // Handle Strapi Dynamic Zones or Blocks
  if (Array.isArray(contentBlocks)) {
    contentBlocks.forEach((block) => {
      // Adjust based on your actual Strapi components structure
      // This is a generic handler for common Strapi rich text or components
      switch (block.__component) {
        case "shared.rich-text":
        case "section.rich-text":
          transformed.push({
            type: "text",
            value: block.body, // Markdown or HTML
          });
          break;
        case "shared.quote":
          transformed.push({
            type: "quote",
            value: block.body,
            author: block.title,
          });
          break;
        case "shared.media":
        case "section.media":
          // Handle both v4 (file.data.attributes) and v5 (file)
          const fileData = block.file?.data?.attributes || block.file;
          if (fileData?.url) {
            transformed.push({
              type: "image",
              value: getStrapiMedia(fileData.url),
              caption: fileData.caption || fileData.alternativeText,
            });
          }
          break;
        case "shared.slider":
          // Handle slider - assuming it has 'files' array
          const files = block.files?.data || block.files;
          if (files && Array.isArray(files)) {
            transformed.push({
              type: "slider",
              value: files.map((f) =>
                getStrapiMedia(f.attributes?.url || f.url)
              ),
            });
          }
          break;
      }
    });
  } else if (typeof contentBlocks === "string") {
    // If content is just a long markdown string
    transformed.push({
      type: "text",
      value: contentBlocks,
    });
  } else if (
    contentBlocks &&
    typeof contentBlocks === "object" &&
    !Array.isArray(contentBlocks)
  ) {
    // Strapi Rich Text (Blocks) object format
    // We might need a renderer, but for now let's try to extract text
    // transforming to the simple {type, value} structure required by Home.js
  }

  return transformed;
};
